
import React, { useEffect, useState } from 'react';
import Header from '@/components/Header';
import { getCurrentUser, isAuthenticated } from '@/utils/auth';
import { useNavigate } from 'react-router-dom';

interface ProfileHeaderProps {
  isAdmin?: boolean;
  onLogout: () => void;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ isAdmin, onLogout }) => {
  const [userRole, setUserRole] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    const checkAuth = () => {
      setIsLoggedIn(isAuthenticated());
      
      const currentUser = getCurrentUser();
      if (currentUser) {
        setUserRole(currentUser.role || '');
      } else {
        // Fallback to localStorage
        setUserRole(localStorage.getItem('userRole') || '');
      }
    };
    
    checkAuth();
  }, []);
  
  const handleLogout = () => {
    onLogout();
    // Always navigate to home page after logout
    navigate('/');
  };
  
  return (
    <Header 
      isLoggedIn={isLoggedIn} 
      isAdmin={isAdmin} 
      userRole={userRole}
      onLogout={handleLogout} 
    />
  );
};

export default ProfileHeader;
